<template>
    <section>
        <div class="about-flex-container" :class="`about-display-${imageposition}`">
            <div class="about-section__element" :class="enableLargerFontSize ? 'about-section__sub-heading' : ''">
                <div v-html="richText"></div>
            </div>
            <div class="about-section__image">
                <img :src="imageurl" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutSection',
    components: {},
    props: {
        imageposition: {
            type: String,
            default: '',
        },
        imageurl: {
            type: String,
            default: '',
        },
        content: {
            type: Object,
            default: () => {},
        },
        enableLargerFontSize: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        richText() {
            return this.content ? this.$storyapi.richTextResolver.render(this.content) : '';
        },
    },
};
</script>

<style scoped lang="scss">
.about-flex-container {
    text-align: center;

    @include media-query(medium) {
        display: flex;
        text-align: left;
    }

    .about-section__image {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 1 auto;

        img {
            max-width: 170px;
        }
    }
}

.about-display-top {
    flex-direction: column-reverse;
}

.about-display-bottom {
    flex-direction: column;
    align-items: center;

    .about-section__image {
        img {
            max-width: 280px;
        }
    }
}

.about-display-left {
    flex-direction: row-reverse;

    .about-section__element {
        @include media-query(medium) {
            flex-basis: 54%;
        }
    }
}

.about-display-right {
    flex-direction: row;

    .about-section__element {
        @include media-query(medium) {
            flex-basis: 54%;
        }
    }
}

.about-flex-container {
    .about-section__element {
        margin: 10px;
        padding-bottom: 20px;

        ::v-deep {
            p {
                font-family: $font-heading;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.43;
                letter-spacing: normal;
                color: $about-section-text;
            }

            h2,
            h3 {
                font-family: $font-heading;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.43;
                letter-spacing: normal;
                color: $about-section-text;
                margin-bottom: 15px;
            }
        }
    }

    .about-section__sub-heading {
        max-width: 580px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        ::v-deep p {
            font-family: $font-heading;
            font-size: 18px !important;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 25px;
            letter-spacing: normal;
            max-width: 100%;
        }
    }
}

.about-flex-container .header-element {
    margin-bottom: 20px;
    font-family: $font-heading;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    color: $about-section-text;
    white-space: nowrap;
}
</style>
